/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { WorkflowApplicationsControllerFindAllQueryResponse, WorkflowApplicationsControllerFindAllQueryParams, WorkflowApplicationsControllerFindAll401, WorkflowApplicationsControllerFindAll403 } from "../../models/workflowsController/WorkflowApplicationsControllerFindAll";

function getWorkflowApplicationsControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/workflow-applications` as const }  
  return res
}

/**
 * @summary List workflow applications (scope-filtered)
 * {@link /api/v1/workflow-applications}
 */
export async function workflowApplicationsControllerFindAll(params?: WorkflowApplicationsControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<WorkflowApplicationsControllerFindAllQueryResponse, ResponseErrorConfig<WorkflowApplicationsControllerFindAll401 | WorkflowApplicationsControllerFindAll403>, unknown>({ method : "GET", url : getWorkflowApplicationsControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}